// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__L_nY9","author":"Table_author__YWBdR","authorImage":"Table_authorImage__pQUY2","unreadRow":"Table_unreadRow__37ZBE"};